import { render, staticRenderFns } from "./HeaderPopupTitle.vue?vue&type=template&id=9541bf1c&scoped=true"
var script = {}
import style0 from "./HeaderPopupTitle.vue?vue&type=style&index=0&id=9541bf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9541bf1c",
  null
  
)

export default component.exports